import { Button } from '@mui/material';
import moment from 'moment';
import React from 'react';

import './styles.scss';

type TimeFiltersProps = {
  selectedTime: string;
  setSelectedTime: React.Dispatch<React.SetStateAction<string>>;
  timeFilters?: string[];
};

export const filterByTime = (values: any[], selectedTime: string) => {
  const today = moment().startOf('day');

  switch (selectedTime) {
    case 'Today':
      return values.filter((item) => {
        const itemDate = moment(item.timestamp);
        return itemDate.isSame(today.clone(), 'day');
      });
    case 'Yesterday':
      return values.filter((item) => {
        const itemDate = moment(item.timestamp);
        return itemDate.isSame(today.clone().subtract(1, 'days'), 'day');
      });
    case 'Last 7 days':
      return values.filter((item) => {
        const itemDate = moment(item.timestamp);
        return itemDate.isAfter(today.clone().subtract(7, 'days'));
      });
    case 'Last 15 days':
      return values.filter((item) => {
        const itemDate = moment(item.timestamp);
        return itemDate.isAfter(today.clone().subtract(15, 'days'));
      });
    case 'Last 30 days':
      return values.filter((item) => {
        const itemDate = moment(item.timestamp);
        return itemDate.isAfter(today.clone().subtract(30, 'days'));
      });
    default:
      return values;
  }
};

export const TimeFilters: React.FC<TimeFiltersProps> = ({
  selectedTime,
  setSelectedTime,
  timeFilters = ['Yesterday', 'Last 7 days', 'Last 15 days', 'Last 30 days'],
}) => {
  const timeFiltersList = ['All', ...timeFilters];

  return (
    <div className="time-filters">
      {timeFiltersList.map((filter) => (
        <Button
          key={filter}
          className={`time-filter-button ${selectedTime === filter ? 'active' : ''}`}
          onClick={() => setSelectedTime(filter)}
        >
          {filter}
        </Button>
      ))}
    </div>
  );
};
